import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthProvider";
import { ROUTES } from "./consts/routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.home} replace />;
  }

  return <>{children}</>;
};
